var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRepeatPayment = function SvgRepeatPayment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#repeat_payment_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.545 4.727h13.637a.909.909 0 0 1 .909.91V12h-1.818V6.545H6.545v2.728L2 5.636 6.545 2v2.727Zm10.91 14.546H3.817a.909.909 0 0 1-.909-.91V12h1.818v5.454h12.727v-2.727L22 18.364 17.454 22v-2.727Z",
    fill: "#7F8286"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "repeat_payment_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgRepeatPayment;